module.exports = __webpack_public_path__ + "img/252845-37-7.398cbbf9.png";